/* eslint-disable */
export default {
  title: 'Son',
  input: 'Entrée',
  microphone: 'Microphone',
  autoAdjustMicLevel: 'Régler automatiquement le volume du micro',
  output: 'Sortie',
  speakerSource: 'Source du haut-parleur',
  speakerVolume: 'Volume du haut-parleur',
  ringtoneSource: 'Sonnerie et source de notification',
  ringtoneVolume: 'Volume de la sonnerie et de la notification',
  ringtones: 'Sonneries',
  noDevices: 'Aucun appareil',
  off: 'Désactivé',
  noLabel: 'Périphérique inconnu',
  stopRecordDescription:
    'Dites quelque chose pour vérifier le volume de votre micro ({countDown} s)',
  stopPlaybackDescription: 'Lecture de votre enregistrement...',
  startRecordButton: 'Tester le microphone',
  stopRecordButton: 'Arrêter l’enregistrement',
  stopPlaybackButton: 'Arrêter le test',
  startTestButton: 'Tester le haut-parleur',
  stopTestDescription: 'Lecture de l’échantillon sonore',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"input"@#@ @source: @#@"Input"@#@
// @key: @#@"microphone"@#@ @source: @#@"Microphone"@#@
// @key: @#@"autoAdjustMicLevel"@#@ @source: @#@"Automatically adjust my mic level"@#@
// @key: @#@"output"@#@ @source: @#@"Output"@#@
// @key: @#@"speakerSource"@#@ @source: @#@"Speaker source"@#@
// @key: @#@"speakerVolume"@#@ @source: @#@"Speaker volume"@#@
// @key: @#@"ringtoneSource"@#@ @source: @#@"Ringtone and notification source"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone and notification volume"@#@
// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"noDevices"@#@ @source: @#@"No devices"@#@
// @key: @#@"off"@#@ @source: @#@"Off"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"stopRecordDescription"@#@ @source: @#@"Say something to check your mic level ({countDown} sec)"@#@
// @key: @#@"stopPlaybackDescription"@#@ @source: @#@"Playing your recording..."@#@
// @key: @#@"startRecordButton"@#@ @source: @#@"Test microphone"@#@
// @key: @#@"stopRecordButton"@#@ @source: @#@"Stop recording"@#@
// @key: @#@"stopPlaybackButton"@#@ @source: @#@"Stop test"@#@
// @key: @#@"startTestButton"@#@ @source: @#@"Test speaker"@#@
// @key: @#@"stopTestDescription"@#@ @source: @#@"Playing sample sound..."@#@
